import type { FontKey } from "../../shared/model";
import { FONTS } from "./style";

let node: HTMLDivElement | null = null;

/** Size of text as the canvas will render it (DOM measurement, so web fonts and wrapping match exactly). */
export function measureText(text: string, font: FontKey, size: number, opts: { maxWidth?: number; bold?: boolean; italic?: boolean } = {}): { w: number; h: number } {
  if (!node) {
    node = document.createElement("div");
    node.setAttribute("aria-hidden", "true");
    node.style.cssText = "position:absolute;left:-100000px;top:0;visibility:hidden;white-space:pre-wrap;overflow-wrap:break-word;padding:0;margin:0;border:0";
    document.body.appendChild(node);
  }
  const f = FONTS[font];
  node.style.fontFamily = f.family;
  node.style.fontSize = size * f.scale + "px";
  node.style.lineHeight = String(f.lineHeight);
  node.style.fontWeight = opts.bold ? "700" : "400";
  node.style.fontStyle = opts.italic ? "italic" : "normal";
  node.style.width = opts.maxWidth ? opts.maxWidth + "px" : "max-content";
  node.textContent = (text || " ") + (text.endsWith("\n") ? "​" : "");
  const r = node.getBoundingClientRect();
  return { w: Math.ceil(r.width) + 4, h: Math.ceil(r.height) };
}
